import Swiper from "swiper";

class InstagramSlider {
  constructor() {
    this.slider();
  }

  slider = () => {
    const slider = new Swiper(".js-ig-swiper", {
      slidesPerView: "auto",
    });
  };
}

new InstagramSlider();
